import React, { FC } from 'react';
import { Pressable, PressableProps } from 'react-native';

export const RipplePressable: FC<PressableProps> = ({ children, ...props }) => (
  <Pressable android_ripple={{ color: '#eaeaea' }} {...props}>
    {children}
  </Pressable>
);
